import React, { useState, useContext, useRef } from "react";
import { SettingsContext } from "./AccountSettingsButton";
import jsDig from "utils/jsDig.js";
import AccountUsers from "client_config/lite/AccountUsers";

export default function Access() {
  const context = useContext(SettingsContext);

  let teamAccess = require("images/lite/icons/teamAccess.png");
  teamAccess = <img className="access-icon" alt="teamAccess" src={`/datapulse${teamAccess}`} />;

  let handshake = require("images/lite/icons/handshake.png");
  handshake = <img className="access-icon" alt="handshake" src={`/datapulse${handshake}`} />;

  return (
    <div className="lite-access-container">
      <div className="client-access">
        <div className="heading-row">
          {handshake} <p>Client Access</p>
        </div>
        <AccountUsers userType="client" />
      </div>
      <div className="team-access">
        <div className="heading-row">
          {teamAccess} <p>Team Access</p>
        </div>
        <AccountUsers userType="employee" />
      </div>
    </div>
  );
}
